export default {
  LIST_CUSTOMER_GIFTS_ISSUED: 'customer-gifts/issued/list',
  LIST_CUSTOMER_GIFTS_ISSUED_NEXT: 'customer-gifts/issued/list/next',
}
